module.exports = __webpack_public_path__ + "img/rapipago.aba6348d.svg";